import { Box, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import React, { useMemo, useState } from "react";

export default function DrugTableInArea({ rowData, gridRef }) {
  const [colDefs] = useState([
    {
      headerName: "ردیف",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 100,
    },
    {
      field: "drugInfo.drugType",
      headerName: "نوع دارو",
      width: 200,
      // cellRenderer: (x) => {
      //   return (
      //     <Box display="flex" alignItems="center">
      //       <Typography fontFamily="Shabnam">
      //         {x.data?.drugInfo?.drugType}
      //       </Typography>
      //     </Box>
      //   );
      // },
    },
    {
      field: "drugInfo.name",
      headerName: "اسم دارو",
      width: 200,
      // cellRenderer: (x) => {
      //   return (
      //     <Box display="flex" alignItems="center">
      //       <Typography fontFamily="Shabnam">
      //         {x.data?.drugInfo?.name}
      //       </Typography>
      //     </Box>
      //   );
      // },
    },
    {
      field: "dose",
      headerName: "دوز دارو",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">
              {x.data?.drugInfo?.dose}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "expireAt",
      headerName: "تاریخ انقضا",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">
              {x.data?.drugInfo?.expireAt?.split("T", 2)[0]}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "producer",
      headerName: "شرکت سازنده",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">
              {x.data?.drugInfo?.producer}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "reminder",
      headerName: "تعداد",
      width: 200,
    },
  ]);

  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: false,
  }));

  return (
    <>
      <div className="ag-theme-quartz" style={{ height: 300, marginTop: 10 }}>
        <AgGridReact
          pagination={true}
          rowHeight={60}
          enableRtl={true}
          rowData={rowData}
            ref={gridRef}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          //   rowSelection={"multiple"}
          //   suppressRowClickSelection={true}
          //   onSelectionChanged={onSelectionChanged}
          //   onCellValueChanged={(event) =>
          //     console.log(`New Cell Value: ${event.value}`)
          //   }
        />
      </div>
      {/* {selection?.length > 0 && <SelectionsTableDrug selection={selection} />} */}
    </>
  );
}
